import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer footer-center p-4 bg-base-300 text-base-content">
      <div>
        <p>Copyright © {currentYear} - Tous droits réservés</p>
      </div>
    </footer>
  );
};

export default Footer;
